import { render, staticRenderFns } from "./CampaignsStatus.vue?vue&type=template&id=02f70b9a&lang=pug"
import script from "./CampaignsStatus.vue?vue&type=script&lang=js"
export * from "./CampaignsStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports